var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "download" }, [
    _c("h1", [_vm._v("Download Now")]),
    _vm._v(" "),
    _vm.isExisted
      ? _c("h3", { staticClass: "default-header-three" }, [
          _vm._v("It looks like you already have an account.")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("h3", { staticClass: "default-header-three" }, [
      _vm._v("Hit 'Download' and start exploring DataMapper.")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttons" }, [
      _c(
        "button",
        {
          staticClass: "simple",
          class: { current: _vm.isMac || _vm.isLinux },
          on: {
            click: function($event) {
              _vm.download(_vm.links.mac)
            }
          }
        },
        [_c("i", { staticClass: "icon-apple" }), _vm._v(" Download for Mac")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "simple",
          class: { current: _vm.isWin || _vm.isLinux },
          on: {
            click: function($event) {
              _vm.download(_vm.links.win)
            }
          }
        },
        [
          _c("i", { staticClass: "icon-windows" }),
          _vm._v(" Download for Windows")
        ]
      )
    ]),
    _vm._v(" "),
    _c("img", {
      attrs: {
        src: require("@/assets/img/safe-online-logo.jpg"),
        alt: "DataMapper logo"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a84fc29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a84fc29","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/Download.vue
// module id = 488
// module chunks = 0